import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { base44 } from "@/api/base44Client";
import { captureAffiliateAttribution } from "@/lib/affiliateAttribution";

// First-touch attribution is retained for 30 days. A landing event is logged
// once per browser session and referral code; conversion attribution is also
// copied onto the business claim itself.
export default function AffiliateAttribution() {
  const location = useLocation();

  useEffect(() => {
    const attribution = captureAffiliateAttribution(location.search, location.pathname);
    if (!attribution?.referral_code) return;
    const key = `yts:affiliate-landing:${attribution.referral_code}`;
    try {
      if (window.sessionStorage.getItem(key)) return;
      window.sessionStorage.setItem(key, "1");
    } catch {
      // The event is still useful if session storage is blocked.
    }
    base44.entities.AffiliateEvent.create({
      referral_code: attribution.referral_code,
      promo_code: attribution.promo_code || "",
      event_type: "Landing",
      source_url: location.pathname || "/",
      occurred_at: new Date().toISOString(),
    }).catch(() => {
      // Tracking must never block browsing.
    });
  }, [location.pathname, location.search]);

  return null;
}
